export default __webpack_public_path__ + "static/media/Liquidity-Black.87b65841.png";